import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';

import { NbinputSignComponent } from './nbinput-sign.component';
import {NbinputTextComponent} from './nbinput-text.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NbinputLabelComponent} from './nbinput-label.component';
import {DpDatePickerModule} from 'ng2-date-picker';
import {NbinputDateComponent} from './nbinput-date.component';
import {NbinputOptionComponent} from './nbinput-option.component';
import {NbinputFilesizePipe} from './nbinput-filesize.pipe';
import {NbinputFileComponent} from './nbinput-file.component';
import {NbinputImageComponent} from './nbinput-image.component';
import {NbinputNumberComponent} from './nbinput-number.component';
import {NbinputUploadService} from './nbinput-upload';
import {ModalGalleryModule} from '@ks89/angular-modal-gallery';
import {NbinputGalleryComponent} from './nbinput-gallery.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {FroalaEditorModule, FroalaViewModule} from '@nbxx/nb-angular-froala';
import {NbinputFroalaComponent} from './nbinput-froala.component';
import {NbinputRatingComponent} from './nbinput-rating.component';
import {NbinputNowComponent} from './nbinput-now.component';
import {NbinputInlineComponent} from './nbinput-inline.component';
import {NbinputFocusDirective} from './nbinput-focus.directive';
import {NbinputCheckComponent} from './nbinput-check.component';
import {NbinputChooseComponent} from './nbinput-choose.component';
import {NbinputExcelComponent} from './nbinput-excel.component';
import {NbinputExcelService} from './nbinput-excel.service';
import {NbStyleDirective} from './nb-style.directive';
import {NbinputViewerComponent} from './nbinput-viewer.component';
import {NbinputSelectComponent} from "./nbinput-select.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DpDatePickerModule,
        NgSelectModule,
        ModalGalleryModule,
        FroalaEditorModule,
        FroalaViewModule,
    ],
    declarations: [
        NbinputFroalaComponent,
        NbinputSignComponent,
        NbinputTextComponent,
        NbinputNumberComponent,
        NbinputLabelComponent,
        NbinputDateComponent,
        NbinputFileComponent,
        NbinputImageComponent,
        NbinputOptionComponent,
        NbinputInlineComponent,
        NbinputGalleryComponent,
        NbinputRatingComponent,
        NbinputCheckComponent,
        NbinputFilesizePipe,
        NbinputFocusDirective,
        NbinputNowComponent,
        NbinputChooseComponent,
        NbinputExcelComponent,
        NbStyleDirective,
        NbinputViewerComponent,
        NbinputSelectComponent,
    ],
    providers: [
        NbinputUploadService,
        NbinputExcelService,
        DecimalPipe,
        NbStyleDirective,
    ],
    exports: [
        NbinputFroalaComponent,
        NbinputSignComponent,
        NbinputTextComponent,
        NbinputCheckComponent,
        NbinputNumberComponent,
        NbinputLabelComponent,
        NbinputDateComponent,
        NbinputFileComponent,
        NbinputImageComponent,
        NbinputOptionComponent,
        NbinputSelectComponent,
        NbinputInlineComponent,
        NbinputGalleryComponent,
        NbinputRatingComponent,
        NbinputNowComponent,
        NbinputChooseComponent,
        NbinputExcelComponent,
        NbStyleDirective,
        NbinputViewerComponent,
    ],
})
export class NbinputModule {
    // public static forRoot(config?: NbinputConfig) {
    //   return {
    //     ngModule: NbinputModule,
    //     providers: [
    //       {provide: NbinputConfig, useValue: config }
    //     ]
    //   };
    // }
    // constructor (@Optional() @SkipSelf() parentModule: NbinputModule) {
    //   if (parentModule) {
    //
    //   }
    // }
}
